<template>
  <z-dialogo ref="dialogoExibirPagamentos" titulo="Recebimentos" :dividers="true" largura="1000px" altura="400px" scrollable>
    <template v-slot:prepend>
      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12" sm="3">
            <v-text-field filled dense v-model="documento.documento" label="Promissória" readonly hide-details></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <z-date-picker-menu filled dense v-model="documento.vencimento" label="Vencimento" readonly hide-details></z-date-picker-menu>
          </v-col>
          <v-col cols="12" sm="3">
            <z-campo-valor filled dense v-model="documento.valor" label="Valor Promissória" readonly hide-details></z-campo-valor>
          </v-col>
          <v-col cols="12" sm="3">
            <z-campo-valor filled dense v-model="documento.valor_restante" label="Valor Restante" readonly hide-details></z-campo-valor>
          </v-col>
        </v-row>
      </v-card-text>
    </template>

    <template v-slot:texto>
      <z-loading :loading="loading" height="100px" color="primary"></z-loading>
      <div v-if="!loading">
        <p class="subtitle-2 font-weight-bold">Recebimentos Efetuados</p>
        <v-divider></v-divider>
        <h3 class="text-center mt-5" v-if="historico.length == 0">Nenhum pagamento efetuado nessa promissória</h3>
        <v-data-table v-if="historico.length > 0" :headers="headers" :items="historico" hide-default-footer>
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.recebimento_id }}</td>
              <td>{{ props.item.created_at | dataBR }}</td>
              <td class="text-right">{{ props.item.valor_atual | valorBR}}</td>
              <td class="text-right font-weight-bold">{{ props.item.valor_pago | valorBR}}</td>
              <td class="text-right">{{ props.item.valor_restante | valorBR}}</td>
            </tr>
          </template>
        </v-data-table>
      </div>

    </template>
    <v-btn color="primary" text @click="fechar">Fechar</v-btn>
  </z-dialogo>
</template>

<script>
import financeiroApi from "@/app/services/financeiro";

  export default {
    name: 'historico-pagamento',

    data () {
      return {
        loading: false,
        historico: [],
        headers: [
          { text: 'Recibo', value: 'recebimento_id', sortable: false},
          { text: 'Data', value: 'created_at', sortable: false},
          { text: 'Valor Original', value: 'valor_original',  align: 'right', sortable: false },
          { text: 'Valor Pago', value: 'valor_pago',  align: 'right', sortable: false },
          { text: 'Valor Restante', value: 'valor_restante', align: 'right', sortable: false },
        ],
        documento: {
          documento: '',
          valor: 0,
          valor_restante: 0
        },

      }
    },

    methods: {
      async abrir(documento) {
        this.documento.documento      = documento.documento;
        this.documento.valor          = documento.valor ? documento.valor : documento.valor_original;
        this.documento.valor_restante = documento.valor_restante;
        this.documento.vencimento     = documento.vencimento;
        this.documento.observacoes    = documento.observacoes;
        this.$refs.dialogoExibirPagamentos.abrir();
        
        try {
          this.loading = true;
          this.historico = await this.carregarHistorico(documento.documento);
        } catch (error) {
          console.log('Algo deu errado ao carregar o histórico de pagamentos: ', error);
        } finally {
          this.loading = false;
        }

        

      },

      fechar() {
        this.$refs.dialogoExibirPagamentos.fechar();
      },

      async carregarHistorico(documento) {
        return await financeiroApi.historicoPagamento(documento);
      }

    }
  }
</script>

<style scoped>

</style>